//TODO: Replace the id with the real V5 tutorial video, once it's created
export const MAPTIVE_TUTORIAL_YOUTUBE_ID = 'JX4OFrjJKBo';
